import { useEffect } from "react";
import MagicalApp from "@/MagicalApp";
import SeasonOnePage from "@/components/magical/SeasonOnePage";
import ResetPasswordPage from "@/components/magical/ResetPasswordPage";
import LegalPage from "@/components/magical/LegalPage";
import AccountPage from "@/components/magical/AccountPage";
import AdminOrdersPage from "@/components/magical/AdminOrdersPage";
import { AuthCallback } from "@/components/magical/AuthCallback";
import { WhatsAppButton } from "@/components/magical/WhatsAppButton";
import { trackEvent } from "@/utils/track";
import "@/components/magical/Auth.css";
import "@/components/magical/AccountLegal.css";

export default function RouteSwitch() {
  useEffect(() => { trackEvent("page_view", { page: window.location.pathname }); }, []);
  let page;
  if (window.location.hash?.includes("session_id=")) page = <AuthCallback />;
  else if (window.location.pathname === "/season-1") page = <SeasonOnePage />;
  else if (window.location.pathname === "/reset-password") page = <ResetPasswordPage />;
  else if (window.location.pathname === "/account") page = <AccountPage />;
  else if (window.location.pathname === "/admin/orders") page = <AdminOrdersPage />;
  else if (window.location.pathname === "/privacy-policy") page = <LegalPage page="privacy" />;
  else if (window.location.pathname === "/terms") page = <LegalPage page="terms" />;
  else if (window.location.pathname === "/shipping") page = <LegalPage page="shipping" />;
  else if (window.location.pathname === "/returns") page = <LegalPage page="returns" />;
  else page = <MagicalApp />;
  return <>{page}<WhatsAppButton /></>;
}
